// extracted by mini-css-extract-plugin
export default {"card":"styles_card__+QOp4","title":"styles_title__urwOC","description":"styles_description__5swRa","downloadButton":"styles_download-button__BgkYh"};